module.exports = __webpack_public_path__ + "img/Pencil.bfaebd14.svg";